class Product {
  constructor() {
    this.initSlider();
    this.initCaseSlider();
  }

  initSlider() {
    const sliders = document.querySelectorAll('.js-product-slider');

    if (!sliders.length || typeof Swiper === 'undefined') {
      return;
    }

    sliders.forEach((el) => {
      const block = el.closest('.s-product-block');
      if (!block) {
        return;
      }

      const prevBtn = block.querySelector('.js-product-slider-prev');
      const nextBtn = block.querySelector('.js-product-slider-next');
      const meterBar = block.querySelector('.js-product-slider-meter span');

      const slideCount = el.querySelectorAll('.swiper-slide').length;

      const updateMeter = (swiper) => {
        if (!meterBar) {
          return;
        }
        const current = swiper.realIndex + 1;
        meterBar.style.width = `${(current / slideCount) * 100}%`;
      };

      const swiper = new Swiper(el, {
        slidesPerView: 1.35,
        spaceBetween: 12,
        watchOverflow: false,
        speed: 600,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.36,
            spaceBetween: 20,
          },
        },
        on: {
          init(swiperInstance) {
            updateMeter(swiperInstance);
          },
          slideChange(swiperInstance) {
            updateMeter(swiperInstance);
          },
        },
      });
    });
  }

  initCaseSlider() {
    const el = document.querySelector('.js-product-case-splide');

    if (!el || typeof Splide === 'undefined') {
      return;
    }

    const section = el.closest('.s-product-case');
    const prevBtn = section?.querySelector('.js-product-case-prev');
    const nextBtn = section?.querySelector('.js-product-case-next');
    const meterBar = section?.querySelector('.js-product-case-meter span');

    const splide = new Splide(el, {
      type: 'loop',
      autoWidth: true,
      gap: '1.6rem',
      focus: 'center',
      arrows: false,
      pagination: false,
      trimSpace: false,
      breakpoints: {
        768: {
          gap: '2rem',
        },
      },
    });

    const updateMeter = () => {
      if (!meterBar) {
        return;
      }

      const total = splide.length;
      if (total <= 0) {
        return;
      }

      const current = splide.index + 1;
      meterBar.style.width = `${(current / total) * 100}%`;
    };

    splide.on('mounted move', updateMeter);
    splide.mount();

    prevBtn?.addEventListener('click', () => splide.go('<'));
    nextBtn?.addEventListener('click', () => splide.go('>'));
  }
}
